
const PowerOfGodsWord = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[550px] flex items-center justify-center"
        style={{
          backgroundImage: "url('./images/power.png')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            The Power of God’s Word: Lessons That Transform Young Hearts
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            Discover how Scripture shapes values, character, and faith in children, creating a foundation for lifelong growth.
          </p>
        </div>
      </div>

      <section className="body--container w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            In a world filled with constant noise, distractions, and competing messages, the enduring power of God’s Word
            continues to shape hearts, minds, and lives. For children, learning and internalizing Scripture is more than
            memorizing verses — it is an invitation to experience God’s love, guidance, and wisdom in a way that transforms
            their character and perspective from an early age.
          </p>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              1. God’s Word Teaches Timeless Values
            </h2>
            <p>
              From the courage of David to the kindness of the Good Samaritan, children learn values like honesty, integrity,
              compassion, empathy, patience, perseverance, forgiveness, and grace. These lessons provide a moral compass that
              guides children’s decisions and interactions for years to come.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              2. Scripture Shapes Character and Identity
            </h2>
            <p>
              Through Bible stories and teachings, children learn they are loved, chosen, and valued by God. This nurtures a
              healthy spiritual identity, building confidence rooted in divine purpose rather than worldly approval.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              3. Encouraging Faith Through Application
            </h2>
            <p>
              Sunday School teaches children to apply Scripture in daily life. Lessons about sharing, kindness, honesty, and
              courage turn abstract principles into meaningful, lifelong habits.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              4. Nurturing Spiritual Curiosity
            </h2>
            <p>
              Children are encouraged to ask questions and explore God’s Word thoughtfully. Curiosity fosters resilient,
              adaptable faith that can grow as children mature.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              5. Building Emotional Resilience
            </h2>
            <p>
              God’s Word offers comfort and hope, helping children develop coping mechanisms and emotional strength rooted in
              faith, equipping them to face challenges throughout life.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              6. Instilling a Love for Prayer and Worship
            </h2>
            <p>
              Pairing Scripture with prayer and worship teaches children to communicate with God regularly, fostering habits
              that deepen their spiritual foundation over time.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              7. Preparing Children to Impact the World
            </h2>
            <p>
              Lessons in service, compassion, and leadership equip children to act with purpose and integrity. They learn that
              faith is a call to love, serve, and inspire others, becoming agents of positive change in families, schools, and
              communities.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              Conclusion: Transforming Hearts for a Lifetime
            </h2>
            <p>
              God’s Word transforms hearts, guides choices, and cultivates lasting faith. Sunday School introduces children
              to Scripture in meaningful ways, allowing lessons to take root and shape compassionate, purposeful, and
              faith-filled individuals for a lifetime.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">God’s Word</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Sunday School</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Character Building</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Faith Formation</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PowerOfGodsWord;